var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"c-table__body"},_vm._l((_setup.props?.parcela?.lista),function(adiantamento){return _c(_setup.LinhaDeAdiantamento,{key:adiantamento?.id,attrs:{"dado":_setup.props?.dado,"parcela":_setup.props?.parcela,"adiantamento":adiantamento},on:{"update:alteraAdiantamento":_setup.alteraAdiantamento}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }